exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container--1YMy2{height:100%;position:relative}", ""]);

// Exports
exports.locals = {
	"container": "container--1YMy2"
};